import { useState, useEffect } from 'react';
import { loginService } from '@/services/login.service';

interface User {
  id: number;
  email: string;
  nome_razao_social: string;
  role: string;
  codigo: string;
}

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('userlogged');

    if (storedToken && storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        setToken(storedToken);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Erro ao verificar autenticação useAuth, fazendo logout:', error);
        logout();
      }
    }
    setIsLoading(false);
  };

  const login = (userData: User, authToken: string, refreshToken: string) => {
    localStorage.setItem('token', authToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('userlogged', JSON.stringify(userData));
    
    setUser(userData);
    setToken(authToken);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userlogged');
    localStorage.removeItem('franquia');
    
    setUser(null);
    setToken(null);
    setIsAuthenticated(false);
  };

  const refreshTokens = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    const user = localStorage.getItem('userlogged');
    const email = user ? JSON.parse(user).email : null;

    if (!refreshToken || !email) {
      logout();
      return false;
    }

    try {
      const response = await loginService.refreshToken(refreshToken, email);

      if (response.idToken && response.refreshToken) {
        localStorage.setItem('token', response.idToken);
        localStorage.setItem('refreshToken', response.refreshToken);
        setToken(response.idToken);
        return true;
      } else {
        logout();
        return false;
      }
    } catch (error) {
      logout();
      return false;
    }
  };

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    login,
    logout,
    refreshTokens,
    checkAuthStatus
  };
};
